
import Schema from 'AppReact/schema';
import { required, optional } from 'AppReact/schema';

const header = {
  sortingField: optional('string'),
  label: required('string'),
}

export default {
  orderBy: Schema('string', 'primitive', { defaultValue: '' }),
  orderDirection: Schema('string', 'primitive', { defaultValue: '' }),
  headers: Schema(header, 'array', { defaultValue: [] }),
  isSelected: Schema('boolean', 'primitive-nullable', { defaultValue: false }),
  hasCheckbox: Schema('boolean', 'primitive-nullable', { defaultValue: false }),
}

